<template>
	<div class="box">
		<!-- 头部 -->
		<div class="nav_div">
			<div class="nav_div_top">
				<div class="nav_left_div">
					<img src="../src/assets/xmsylogo.png" alt="" class="nav_left_div_img" />
					<!-- 慧萌源 -->
				</div>
				
				<div class="nav_div_top-c">
					<el-button ><i class="el-icon-location-information el-icon--left"></i>山东<i class="el-icon-arrow-down el-icon--right"></i></el-button>
					<!-- v-model="input3" -->
					<el-input  class="input-with-select" readonly placeholder="请输入院校名称" v-model="indexTopName" @focus="schGet" @keyup.enter.native="schGet" @clear="schGet">
						<el-button type="danger" slot="append" icon="el-icon-search" @click="schGet">搜索</el-button>
					</el-input>
					<div style="display: flex;">
						<el-button  @click="openVip" v-if="!token||(user&&user.userVip==0)" class="elbu-vip"  type="warning"><img src="../src/assets/img/vip.png" alt=""/>开通VIP</el-button>
						<el-button  @click="openVip" v-if="token&&(user&&user.userVip==1)" class="elbu-vip"  type="warning"><img src="../src/assets/img/vip.png" alt=""/>VIP</el-button>
						<el-button  type="danger" plain @click="noopsycheOpen = true" v-if="!token">登录/注册</el-button>
						
						
						<el-dropdown size="mini" @command="(command) => handleCommand(command)" v-else>
						  <span class="el-dropdown-link" style="display: flex;align-items: center;">
						    <img style="width: 40px;height: 40px;margin-left: 10px;margin-right: 6px;" src="./assets/img/n6.png" alt="" />{{user&&user.mobile&&user.mobile.slice(-4)}}<i class="el-icon-d-arrow-right el-icon--right"></i>
						  </span>
						  <el-dropdown-menu slot="dropdown">
						    <el-dropdown-item command="handleQuit" icon="">退出登录</el-dropdown-item>
						  </el-dropdown-menu>
						</el-dropdown>
					</div>
					
				</div>

			</div>
			<div class="nav_center_div">
				<el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect"
					active-text-color="#9b0e12" router>
					<!--  text-color='#000' -->
					<!-- active-text-color="#9b0e12" -->
					<el-menu-item  @click="goindex" > 首页 </el-menu-item>
					<el-submenu index="/Ainformation">
						<template slot="title">
							<!-- <div class="nav_div_title" @click="zoujin"> 走进学盟 </div> -->
							查数据 <i class="el-icon-caret-bottom "></i>
						</template>
						<el-menu-item index="/Ainformation/school">找大学</el-menu-item>
						<el-menu-item index="/Ainformation/major">查专业</el-menu-item>
						<el-menu-item index="/Ainformation/occupation">看职业</el-menu-item>
						<el-menu-item index="/Ainformation/batchBorder">查批次线</el-menu-item>
						<el-menu-item index="/Ainformation/subsection">一分一段</el-menu-item>
						<el-menu-item index="/Ainformation/shamSchool">学科评估</el-menu-item>
						<el-menu-item @click="tiqiP" >提前批</el-menu-item>

					</el-submenu>
					
					<el-submenu index="/AAIvol">
						<template slot="title">
							<!-- <div class="nav_div_title" @click="zoujin"> 走进学盟 </div> -->
							AI志愿 <i class="el-icon-caret-bottom "></i>
						</template>
						<el-menu-item @click="volClick" >AI智能填报 <img style="width: 18px;height: 12px;" src="../src/assets/img/vip.png" alt="" /></el-menu-item>
					
					</el-submenu>
					<el-submenu index="/AAppraisal">
						<template slot="title">
							<!-- <div class="nav_div_title" @click="zoujin"> 走进学盟 </div> -->
							测评中心 <i class="el-icon-caret-bottom "></i>
						</template>
						<el-menu-item @click="cccc">MBTI</el-menu-item>
						<el-menu-item @click="cccc">霍兰德</el-menu-item>
						<el-menu-item @click="cccc">多元智能</el-menu-item>
						<el-menu-item @click="cccc">学科兴趣</el-menu-item>
						<el-menu-item @click="cccc">职业兴趣</el-menu-item>
					</el-submenu>
					<el-menu-item index="/Examination">成人高考</el-menu-item>
					<el-menu-item index="/ExaminationKf">国家开放大学</el-menu-item>
					<el-menu-item index="/Ainternational">韩国留学</el-menu-item>
					<!-- <el-submenu index="/NewsCenter">
          <template slot="title">
            新闻中心
          </template>
          <el-menu-item index="/NewsCenter/groupAct"
            >集团动态</el-menu-item
          >
          <el-menu-item index="/NewsCenter/businessAct"
            >行业动态</el-menu-item
          >
          <el-menu-item index="/NewsCenter/videoAll"
            >视频中心</el-menu-item
          >
          <el-menu-item index="/NewsCenter/campusTale">校区故事</el-menu-item>
        </el-submenu> -->

					<!-- <el-menu-item index="/WorkingSystem">业务体系</el-menu-item> -->
					<!-- <el-submenu index="/XMFU">
          <template slot="title">
            <div class="nav_div_title">学盟服务</div>
          </template>
          <el-menu-item index="/XMFU/fourSer">四师服务</el-menu-item>
          <el-menu-item index="/XMFU/selectXm" class="font"
            >选择学盟的理由</el-menu-item
          >
          <el-menu-item index="/XMFU/mienXm">学员风采</el-menu-item>
        </el-submenu>
        <el-menu-item index="/league">集团党建</el-menu-item>
        <el-menu-item index="/contact">联系我们</el-menu-item> -->
				</el-menu>
			</div>

			
		</div>
		
		<!-- :before-close="handleClose" -->
		<!-- 登录弹框 -->
		<el-dialog title="" :visible.sync="noopsycheOpen" width="40vw" append-to-body class="view-dialog" >
			
			<div class="alert">
				<div class="alerttit" v-if="cardIndx==1">手机验证码登录</div>
				<div class="alerttit" v-if="cardIndx==2">激活码登录</div>
				<div class="alertcen">
					<div class="alertcenA"><input v-model="mobile" placeholder="请输入手机号" maxlength="11"></input></div>
					<div class="alertcenB"  v-if="cardIndx==1" >
						<input v-model="codes" placeholder="请输入验证码"  maxlength="4"></input> 
						<div v-show="show" class="codebtn" @click="getCode">获取验证码</div>
						<div v-show="!show" class="codebtn" >{{count}}</div>
					 </div>
					 
					 <div class="alertcenB"  v-if="cardIndx==2" >
					 	<input style="width: 80%;" v-model="cardNum" placeholder="请输入激活码" maxlength="12"></input> 
					  </div>
					 
					 <div class="alertcenC">
						 <div v-if="cardIndx==1" @click="cardClick(2)">激活码登录</div>
						 <div v-if="cardIndx==2" @click="cardClick(1)">验证码登录</div>
					 </div>
					 <div class="alertcenD">
						 <div v-if="!onoff" @click="formSub(cardIndx)">{{cardIndx==1?'注册/登录':'登录'}}</div>
						 <div v-else >{{cardIndx==1?'注册/登录':'登录'}}</div>
					 </div>
					 
					 <div class="xuan">
					 	<div class="xieyi">
					 		<div class="xieyi-check">
								<!-- <el-checkbox v-model="checked">备选项</el-checkbox> -->
					 			<span class="iconfont el-icon-circle-check" :style="{color:xieyishow?'#E72F29':'#C3C7CC'}" @click="xieyiClick()"></span>
					 		</div>
					 		<div class="xieyi-text">
					 			<span  @click="xieyiClick()">请阅读并同意 </span>
					 			<span style="color: #E72F29;" class="yuedu" @click="yudu('userAgr')">《用户服务协议》</span>
					 			及
					 			<span  style="color: #E72F29;" class="yuedu" @click="yudu('privacyAgr')">《隐私协议》</span>
					 		</div>
					 	</div>
					 </div>
				</div>
			</div>	
			
		</el-dialog>
		
		<!-- 基本信息 -->
		<el-dialog  title="基本信息" :visible.sync="open"  width="50vw" append-to-body class="view-dialog">
		  <div class="maintop" v-if="form.batNameRemark">
		    <div class="maintopcen">
		     <i class="el-icon-warning maintopcenleft"></i>
		      <div class="maintopcenrigth">
		          <h3>{{form.batNameRemark}}</h3>
		          <!-- <h4>音乐类、表（导）演类（含服装表演类+戏剧影视表演类+戏剧影视导演类）、舞蹈类填报表格请联系客服人员获取</h4> -->
		      </div>
		    </div>
		  </div>
		  <el-form ref="form" :model="form" :rules="rules" label-width="80px" class="elform">
		    <el-row :gutter="24">
		     <el-col :span="12">
		       <el-form-item label="省份" prop="cityId">
		           <el-select v-model="form.cityId" placeholder="请选择省份"  @change="cityChange">
		             <el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.id" />
		           </el-select>
		       </el-form-item>
		      </el-col>
		      <el-col :span="12" >
		       <el-form-item label="批次" prop="batchId">
		            <el-select v-model="form.batchId" placeholder="请选择批次" clearable  @change="batchChange">
		              <el-option v-for="item in categoryList" :key="item.id" :label="item.name"
		                :value="item.id" />
		            </el-select>
		       </el-form-item>
		      </el-col>
		    </el-row>
		    <el-row :gutter="24">
		      <!-- <el-col :span="7">
		       <el-form-item label="学生姓名" prop="name">
		         <el-input v-model="form.name" placeholder="学生姓名" />
		       </el-form-item>
		      </el-col> -->
		      <!-- <el-col :span="7">
		       <el-form-item label="联系方式" >
		         <el-input v-model="form.mobile" maxlength="11" placeholder="联系方式" />
		       </el-form-item>
		      </el-col> -->
		     <!-- <el-col :span="7">
		       <el-form-item label="性别" prop="sex">
		          <el-radio-group v-model="form.sex">
		            <el-radio-button :label="1">男</el-radio-button>
		            <el-radio-button :label="2">女</el-radio-button>
		          </el-radio-group>
		       </el-form-item>
		      </el-col> -->
		      <!-- <el-col :span="7">
		       <el-form-item label="专业批次" >
		        <el-select v-model="form.name" placeholder="请选择专业批次" clearable >
		          <el-option v-for="item in shopNameoption" :key="item.name" :label="item.name"
		            :value="item.name" />
		        </el-select>
		       </el-form-item>
		      </el-col> -->
		      <el-col :span="12">
		       <el-form-item label="文化成绩" prop="culture">
		         <el-input v-model="form.culture" placeholder="文化成绩" @input="handleInput" />
		       </el-form-item>
		      </el-col>
		      <el-col :span="12" v-if="form.batNameSSS!='普通类'&&form.batNameSSS!='春季高考'&&form.batNameSSS">
		       <el-form-item label="专业成绩" prop="art">
		         <el-input v-model="form.art" placeholder="专业成绩" @input="handleInput"/>
		       </el-form-item>
		      </el-col>
		
		      <el-col :span="12" v-if="form.batNameSSS!='普通类'&&form.batNameSSS!='春季高考'&&form.batNameSSS">
		       <el-form-item label="综合成绩" prop="score">
		         <el-input v-model="form.score" placeholder="综合成绩" disabled/>
		       </el-form-item>
		      </el-col>
		
		      <el-col :span="12">
		       <el-form-item label="位次" prop="scorePtn">
		         <el-input v-model="form.scorePtn" placeholder="位次" />
		       </el-form-item>
		      </el-col>
		    </el-row>
		    <el-row :gutter="28">
		      <el-col :span="28">
		       <el-form-item label="选科类型" prop="subjectOne">
		         <el-checkbox-group v-model="form.subjectOne" :max="3" @change="xuankeChange" >
		            <el-checkbox-button v-for="item in subjectDown" :label="item.id" :key="item.id" >{{item.name}}</el-checkbox-button>
		          </el-checkbox-group>
		       </el-form-item>
		      </el-col>
		    </el-row>
		    <!-- <el-row :gutter="28">
		      <el-col :span="14">
		       <el-form-item label="备注" >
		         <el-input v-model="form.remark" placeholder="备注" />
		       </el-form-item>
		      </el-col>
		    </el-row> -->
		  </el-form>
		  <div slot="footer" class="dialog-footer" >
		    <el-button @click="cancel">取 消</el-button>
		    <el-button type="danger" @click="submitForm">提 交</el-button>
		  </div>
		</el-dialog>
		
		<!-- 激活 VIP -->
		<el-dialog title="" :visible.sync="vipOpen" width="40vw" append-to-body class="view-dialog" >
			<div class="userbox" v-if="user">
				<div class="userboxl">
					<div class="userboxla" >{{user.cityName?user.cityName+'考生':''}}</div>
					<div class="userboxlb">
						{{user.subjectOnes}}/{{user.score/100}}/{{user.scorePtn}}位
					</div>
					<div class="userboxlc" v-if="user.userVip==0">您还不是会员，开通立享超多权益</div>
					<div class="userboxlc" v-else>
						您已是会员 
						<div v-if="user.overdueTime">
							到期时间：{{user.overdueTime|dateFilter}}
						</div>
					</div>
				</div>
				<div class="userboxr">
					<div class="userboxrbMain"  v-if="user.userVip==0">
						 <input type="text" placeholder="请输入激活码" maxlength="12" v-model="valuenum"> 
						 <div class="userboxrb" @click="wancheng">
							 卡密激活
						 </div>
					</div>
					
					<!-- <div class="" v-else>
						<image style="width: 92rpx;height: 40rpx;" src="../static/image/vip3.png" mode=""></image>
					</div> -->
					
				</div>
				
			</div>
			
			<div class="qymain">
				<div class="qymaintop">
					<img :src="UPLODE_URL+'17325008466601645.png'" alt="">
					<div class="qymaintop-tit">
						VIP专享十大权益
					</div>
				</div>
				<div class="qymainlist">
					<div class="qymainlistl">
						<div class="qymainlistl-top">权益</div>
						<div class="qymainlistl-list">
							<div class="qymainlistllist-li">院校数据随便查</div>
							<div class="qymainlistllist-li">AI精准匹配院校</div>
							<div class="qymainlistllist-li">录取概率估算</div>
							<div class="qymainlistllist-li">稳保院校推荐</div>
							<div class="qymainlistllist-li">一分一段表</div>
							<div class="qymainlistllist-li">模拟志愿填报</div>
							<div class="qymainlistllist-li">志愿表一键导出</div>
							<div class="qymainlistllist-li">专家精品课程</div>
							<div class="qymainlistllist-li">VIP专属客服</div>
						</div>
					</div>
					
					<div class="qymainlistl qymainlistlback">
						<div class="qymainlistl-top qymainlistl-topb">VIP会员</div>
						<div class="qymainlistl-list qymainlistl-listb qymainlistl-listback">
							
							<div class="el-iconNew el-icon-circle-check" style="color: #F44540;font-size: 19px;"></div>
							<div class="el-iconNew el-icon-circle-check" style="color: #F44540;font-size: 19px;"></div>
							<div class="el-iconNew el-icon-circle-check" style="color: #F44540;font-size: 19px;"></div>
							<div class="el-iconNew el-icon-circle-check" style="color: #F44540;font-size: 19px;"></div>
							<div class="el-iconNew el-icon-circle-check" style="color: #F44540;font-size: 19px;"></div>
							<div class="el-iconNew el-icon-circle-check" style="color: #F44540;font-size: 19px;"></div>
							<div class="el-iconNew el-icon-circle-check" style="color: #F44540;font-size: 19px;"></div>
							<div class="el-iconNew el-icon-circle-check" style="color: #F44540;font-size: 19px;"></div>
							<div class="el-iconNew el-icon-circle-check" style="color: #F44540;font-size: 19px;"></div>
							
							
							<!-- <u-icon name="checkmark-circle-fill" color="#F44540" size="19"></u-icon>
							<u-icon name="checkmark-circle-fill" color="#F44540" size="19"></u-icon>
							<u-icon name="checkmark-circle-fill" color="#F44540" size="19"></u-icon>
							<u-icon name="checkmark-circle-fill" color="#F44540" size="19"></u-icon>
							<u-icon name="checkmark-circle-fill" color="#F44540" size="19"></u-icon>
							<u-icon name="checkmark-circle-fill" color="#F44540" size="19"></u-icon>
							<u-icon name="checkmark-circle-fill" color="#F44540" size="19"></u-icon>
							<u-icon name="checkmark-circle-fill" color="#F44540" size="19"></u-icon>
							<u-icon name="checkmark-circle-fill" color="#F44540" size="19"></u-icon> -->
						</div>
					</div>
					<div class="qymainlistl" style="flex: 0.8;">
						<div class="qymainlistl-top qymainlistl-topb">非会员</div>
						<div class="qymainlistl-list qymainlistl-listb">
							<div class="el-iconNew el-icon-circle-close" style="color: #B8B8D1;font-size: 19px;"></div>
							<div class="el-iconNew el-icon-circle-close" style="color: #B8B8D1;font-size: 19px;"></div>
							<div class="el-iconNew el-icon-circle-close" style="color: #B8B8D1;font-size: 19px;"></div>
							<div class="el-iconNew el-icon-circle-close" style="color: #B8B8D1;font-size: 19px;"></div>
							<div class="el-iconNew el-icon-circle-close" style="color: #B8B8D1;font-size: 19px;"></div>
							<div class="el-iconNew el-icon-circle-close" style="color: #B8B8D1;font-size: 19px;"></div>
							<div class="el-iconNew el-icon-circle-close" style="color: #B8B8D1;font-size: 19px;"></div>
							<div class="el-iconNew el-icon-circle-close" style="color: #B8B8D1;font-size: 19px;"></div>
							<div class="el-iconNew el-icon-circle-close" style="color: #B8B8D1;font-size: 19px;"></div>
							
							
							<!-- <u-icon name="close-circle" color="#B8B8D1" size="19"></u-icon>
							<u-icon name="close-circle" color="#B8B8D1" size="19"></u-icon>
							<u-icon name="close-circle" color="#B8B8D1" size="19"></u-icon>
							<u-icon name="close-circle" color="#B8B8D1" size="19"></u-icon>
							<u-icon name="close-circle" color="#B8B8D1" size="19"></u-icon>
							<u-icon name="close-circle" color="#B8B8D1" size="19"></u-icon>
							<u-icon name="close-circle" color="#B8B8D1" size="19"></u-icon>
							<u-icon name="close-circle" color="#B8B8D1" size="19"></u-icon>
							<u-icon name="close-circle" color="#B8B8D1" size="19"></u-icon> -->
						</div>
					</div>
				</div>
				
				<!-- 使用说明 -->
				<div class="explain-box">
					<div class="explain-b-tit"> 使用说明 </div>
					
					<div class="explain-boxul">
						<div class="explain-boxul-li">
							<span class="exnum">1</span>
							<div class="extext">开通VIP前请确认开通省份和高考年份，开通后无法修改西藏地区暂不支持服务。</div>
						</div>
						<div class="explain-boxul-li">
							<span class="exnum">2</span>
							<div class="extext">本产品适合本科及专科批次志愿模拟填报使用。</div>
						</div>
						<div class="explain-boxul-li">
							<span class="exnum">3</span>
							<div class="extext">本系统仅提供志愿填报参考服务，招生计划与录取数据请以学校官方或考试院公布为准。</div>
						</div>
						<div class="explain-boxul-li">
							<span class="exnum">4</span>
							<div class="extext">正式填报请前往考试院官网，并根据官方信息，做好志愿核对。</div>
						</div>
					</div>
					
				</div>
				<!-- 使用说明 -->
				<div class="explain-box" style="padding-bottom: 50rpx;">
					<div class="explain-b-tit"> 免责说明 </div>
					<div class="explain-boxulmz ">
						<div class="explain-boxul-limz">
							<div class="extext">在您使用本产品前，请务必阅读以下声明</div>
						</div>
						<div class="explain-boxul-limz">
							<div class="extext">1.本志愿模拟填报服务是根据高考录取政策、往年高校录取情况、考生考试情况、招生数据等历史数据而提供的服务由于招生计划、考试实际情况每年均会变化，请您理解，本服务推荐的志愿学校和专业不等于您的实际录取情况，仅供您参考。</div>
						</div>
						<div class="explain-boxul-limz">
							<div class="extext">2.我们建议您在正式进行志愿填报时，请向相关高校进一步咨询确认，并根据自己的实际情况做出选择。</div>
						</div>
						<div class="explain-boxul-limz">
							<div class="extext">3.请您特别注意高考志愿填报都具有一定风险性，我们无法对您的录取结果提供任何保证或担保。</div>
						</div>
						<div class="explain-boxul-limz">
							<div class="extext">4.本志愿服务使用的招生数据来源于各省教育考试院以及各高校官方公布信息。</div>
						</div>
					</div>
				</div>
			</div>
			
		</el-dialog>
		
		
		<!-- 客服 -->
		<!-- <div class="session">
			<el-popover
			  placement="right"
			  width="170"
			  trigger="hover">
				<img :src="UPLODE_URL+'17359573499021241.jpg'" alt="" style="width: 170px;height: 170px;"/>
				<div style="text-align: center;color: #F75950;">扫描添加老师咨询</div>
			  <div slot="reference"><img style="cursor: pointer" :src="UPLODE_URL+'17355438543421729.png'" alt="" /></div>
			</el-popover>
		</div> -->
		
		<!-- 路由 -->
		<div class="middle_div">
			<keep-alive>
				<router-view></router-view>
			</keep-alive>
		</div>
		
	</div>
</template>

<script>
	import { links,  } from "@/api/APP";
	import moment from 'moment'
	import  {UPLODE_URL} from '@/utils/request'
	import { EventBus } from '@/utils/event-bus.js';
	export default {
		filters: {
		  // 日期过滤器 显示年月日时分
		  dateFilter(type) {
		    if (type) {
		      type = Number(type)
		      return moment(type).format('YYYY-MM-DD HH:mm:ss')
		    } else {
		      return '暂无时间'
		    }
		  },
		},
		data() {
			return {
				isLoggedIn: false,
				
				UPLODE_URL,
				indexTopName:'',
				
				vipOpen:false,//激活vip 弹框
				valuenum:'',//kami
				
				
				noopsycheOpen:false,//登录弹框
				show:true,
				timer: null,
				count: '',
				mobile:'',
				codes:'',
				cardNum:'',
				cardIndx:1,
				onoff: false,
				xieyishow: false,
				user:JSON.parse(localStorage.getItem('user')),
				token: localStorage.getItem('token')||'',
				pushFlag:localStorage.getItem('pushFlag')||'',
				
				
				// 基本信息
				open:false,
				categoryList:[],//批次
				checkboxGroup1:[],//选课批次的值
				cityList:[],//省份
				rowData:{},
				form: {
					id:'',
				  cityId:'',//省份id
				  cityYear:'',//省份里面带的年 查询位次会用到
				  batchId:'',//int(20) NULL	批次id
				  batNameSSS:'',//判断是普通类还是艺术类
				  batNameRemark:'',//选择完了批次 上面展示提示的提示文字
				  statusType:'',	//int(20) NULL	1(6选3), 2(3+1+2), 3(7选3), 4(文理科)
				  name:'',	//varchar(50) NULL	学生姓名
				  mobile:'',	//varchar(11) NULL	手机号
				  sex:'',	//int(1) NULL	1男2女
				  culture:'',	//int(10) NULL	文化分
				  art:'',	//int(10) NULL	专业分
				  score:'',	//int(10) NULL	综合成绩
				  scorePtn:'',	//int(10) NULL	位次
				  subjectOne:[],//varchar(20) NULL	1物理，2化学，3生物，4历史，5政治，6地理，7文科，8理科
				  subjectTwo:[],	//varchar(20) NULL	1物理，2化学，3生物，4历史，5政治，6地理，7文科，8理科
				  userVip:'',	//int(1) NULL	vip，0否，1是
				  scoreNum:'',	//int(5) NULL	分数可修改次数
				  cityNum:'',	//int(5) NULL	省份可修改次数
				  kemuNum:'',	//int(5) NULL	科目可修改次数
				  remark:'',	//varchar(200) NULL	备注
				},
				// 表单校验
				rules: {
				  cityId: [{ required: true, message: "请选择", trigger: ["blur", "change"]  }],
				  batchId: [{ required: true, message: "请选择", trigger: ["blur", "change"]  }],
				  name: [{ required: true, message: "请输入", trigger: ["blur", "change"]  }],
				  sex: [{ required: true, message: "请选择", trigger: ["blur", "change"]  }],
				  culture: [{ required: true, message: "请输入", trigger: ["blur", "change"]  }],
				  art: [{ required: true, message: "请输入", trigger: ["blur", "change"]  }],
				  score: [{ required: true, message: "请选择", trigger: ["blur", "change"]  }],
				  scorePtn: [{ required: true, message: "请输入", trigger: ["blur", "change"]  }],
				  subjectOne: [{ required: true, message: "请选择", trigger: ["blur", "change"]  },{
				      validator: (rule, value, callback) => {
				        if (value.length !== 3) {
				          callback(new Error('缺少选科'));
				        } else {
				          callback();
				        }
				      },
				      trigger: ["blur", "change"]
				    }]
				},
				subjectDown: [{name:'物理',id:1},{name:'化学',id:2},{name:'生物',id:3},{name:'历史',id:4},{name:'政治',id:5},{name:'地理',id:6}],//选科批次
				
				
				
				
				
				
				
				
				activeIndex: "1",
				navtab: false,
				link: {},
				partners: []
			};
		},
		
		created() {
			this.allGet()
			// 首页 信息回显
			EventBus.$on('showModal', () => {
			  this.addUserShow()
			});
			
			// 激活弹框
			EventBus.$on('vipOpen', () => {
			  this.vipOpen = true
			});
			// 激活弹框
			EventBus.$on('open', () => {
			  this.open = true
			});
			// 登录弹框
			EventBus.$on('noopsycheOpen', () => {
			  this.noopsycheOpen = true
			});
			
			
			// 添加 storage 事件监听器
			window.addEventListener('storage', this.handleStorageEvent);
		},
		beforeDestroy() {
		    EventBus.$off('showModal');
			EventBus.$off('vipOpen');
			EventBus.$off('noopsycheOpen');
			EventBus.$off('open');
		},
		mounted() {
			this.pushFlag = localStorage.getItem('pushFlag')||''
		},
		methods: {
			// 和小程序同步信息
			getUSerInfo(){
				
				this.api.appMyInfoApi().then(res => {
					if(res.code==200){
						console.log('res信息',res.data)
						localStorage.setItem("user", JSON.stringify(res.data));
					}else{
						this.$message.error(res.data.msg);
					}
				})
			},

			handleStorageEvent(event) {
			      // 处理 storage 事件
			      if (event.key === 'loginStatus') {
			        // 更新登录状态
					console.log('更新登录状态更新登录状态更新登录状态更新登录状态')
			        // this.checkLoginStatus();
			      }
			    },
				checkLoginStatus() {
				      // 从 localStorage 获取登录状态
				      // const loginStatus = localStorage.getItem('loginStatus');
				      // this.isLoggedIn = loginStatus === 'loggedIn';
					  console.log('checkLoginStatuscheckLoginStatuscheckLoginStatuscheckLoginStatuscheckLoginStatuscheckLoginStatus')
				    },
				
				
				
				
				
			// 搜索 直接到找大学页面
			schGet(){
				this.$router.push({path:'/Ainformation/school'})
			},
			volClick(){
					if(!this.token) {
						// EventBus.$emit('noopsycheOpen');
						this.noopsycheOpen = true
					}else if(!this.user.score){
						// EventBus.$emit('showModal');
						this.open = true
						return
					}else{
						this.$router.push({path:'/AAIvol/vol'})
						
					}
			},
			tiqiP(){
				this.$router.push({path:'/Ainformation/advance?t='+ Date.now()})
				
			},
			goindex(){
				this.$router.push({path:'/'})
				window.location.reload()
			},
			cccc(){
					if(!this.token) {
						// EventBus.$emit('noopsycheOpen');
						this.noopsycheOpen = true
					}else if(!this.user.score){
						// EventBus.$emit('showModal');
						this.open = true
						return
					}else{
						let URL=`https://el.baizebang.com?id=${this.user.id}`
						window.open(URL, '_blank');
					}
			},
			yudu(item){
					const route =this.$router.resolve({name:item,})
					window.open(route.href, '_blank');
			},
			// 回显
			addUserShow(){
				this.api.appMyInfoApi().then(res => {
					if(res.code==200){
						console.log('res信息',res.data)
						localStorage.setItem("user", JSON.stringify(res.data));
						
						this.rowData={}
						if(JSON.parse(localStorage.getItem('user'))){
							this.rowData =JSON.parse(localStorage.getItem('user'))
							this.rowData.art = this.rowData.art?this.rowData.art/100:''
							this.rowData.culture = this.rowData.culture?this.rowData.culture/100:''
							this.rowData.score = this.rowData.score?this.rowData.score/100:''
						}
						
						if(this.rowData.subjectOne){
							if(this.rowData.subjectOne&&typeof(this.rowData.subjectOne)=='string'){
							 this.rowData.subjectOne = this.rowData.subjectOne.split(',').map(item => Number(item));
							}
						}else{
							this.rowData.subjectOne =[]
						}
						
						this.form =this.rowData
						this.form.cityYear = this.rowData.year
						this.getCategory(this.rowData.cityId,1)
						
					}else{
						this.$message.error(res.data.msg);
					}
				})
				console.log('this.form',this.form)
				this.open = true;
			},
			// 回显LL
			addUserShowLL(){
				
				this.api.appMyInfoApi().then(res => {
					if(res.code==200){
						localStorage.setItem("user", JSON.stringify(res.data));
						this.rowData={}
						if(JSON.parse(localStorage.getItem('user'))){
							this.rowData =JSON.parse(localStorage.getItem('user'))
							this.rowData.art = this.rowData.art?this.rowData.art/100:''
							this.rowData.culture = this.rowData.culture?this.rowData.culture/100:''
							this.rowData.score = this.rowData.score?this.rowData.score/100:''
						}
						
						
						if(this.rowData.subjectOne){
							if(this.rowData.subjectOne&&typeof(this.rowData.subjectOne)=='string'){
							 this.rowData.subjectOne = this.rowData.subjectOne.split(',').map(item => Number(item));
							}
						}else{
							this.rowData.subjectOne =[]
						}
						
						
						
						
						this.form =JSON.parse(JSON.stringify(this.rowData))
						this.form.cityYear = this.rowData.year
						this.getCategory(this.rowData.cityId,1)
						
					}else{
						this.$message.error(res.data.msg);
					}
				})
				
				
				
				
				
			},

			// 点击开通VIP按钮
			openVip(){
				
				
				
				
				
				this.user=JSON.parse(localStorage.getItem('user'))
				this.token= localStorage.getItem('token')||''
				
				if(!localStorage.getItem('token')) {
					// 登录弹框
					EventBus.$emit('noopsycheOpen');
					return
				}
				
				if(!this.user.score) {
					// 个人信息弹框
					EventBus.$emit('showModal');
					return
				}
				
				
				this.vipOpen = true
			},
			// 确定激活
			wancheng() {
				// let user = this.user
				// user.userVip = 1
				// localStorage.setItem("user", JSON.stringify(user));
				// EventBus.$emit('tui');
				// window.location.reload()
				// return
				
				
				let that = this;
				let code = that.valuenum;
				if (code == "") {
					console.log('停住了')
					this.$message.error('请填写正确的激活码');
					return
				}
				let reg = RegExp(/-/);
				if (reg.exec(code)) {
					code = code.replace(/\-/g, "")
				}
				if(code.length<12){
					this.$message.error('请填写正确的激活码');
					return
				}
				if (code) {
					let quer = {
						cardPwd: code
					}
					this.api.GetAppCardApi(quer).then(res => {
						if(res.code==200){
							if(res.data.message=='激活成功'){
								this.$message.success(res.data.message);
								localStorage.setItem("cardType", 1);
								let user = this.user
								user.userVip = res.data.status
								if(res.data.overdueTime){
									user.overdueTime = res.data.overdueTime
								}
								localStorage.setItem("user", JSON.stringify(user));
								that.valuenum = ''
								that.user = user
								EventBus.$emit('tui');
								window.location.reload()
							}else{
								this.$message.error(res.data.message);
							}
						}else{
							this.$message.error(res.data.msg);
						}
					})
				} else {
					this.$message.error('请输入激活码');
				}
			},
			
			
			/************S*******************************************************************************/
			allGet(){
				
				// this.api.GetAppCityApi({cityId:37}).then(res => {this.cityList = res.data})
				this.api.homeCityListShanApi({cityId:37}).then(res => {this.cityList = res.data})

				// this.api.GetAppBatchListApi({cityId:37}).then(res => {this.categoryList = res.data})
			},
			// 选完省份 去请求批次 --就是文档中的批次接口
			getCategory(id,i){
			  let data = {
			    cityId:id,
			  }
			  this.api.GetAppBatchListApi(data).then(res => {
			    if(res.data){
			       this.categoryList = res.data;
			       // 修改时候回显
			       if(i==1){
			         // this.form.batNameSSS =
					 if(this.form.batchId){
						 this.form.batNameSSS = this.categoryList.find(o => o.id == this.form.batchId).batchName
						 this.form.batNameRemark = this.categoryList.find(o => o.id == this.form.batchId).remark
					 }
			        
			       }
			    }
			  });
			},
			
			// @chang
			
			// 省份选择
			cityChange(e){
			  console.log('省份选择e',e)
			  this.form.cityYear = this.cityList.find(o => o.id == e).year;
			  this.getCategory(this.form.cityId)
			
			  // 选择完省份 把批次的值和下拉选择数组 清空
			  this.form.batchId = ''
			  this.form.batNameSSS = ''
			  this.form.batNameRemark = ''
			  this.categoryList=[]
			},
			// 批次选择
			batchChange(e){
			  this.form.culture = ''
			  this.form.art = ''
			  this.form.score = ''
			   this.form.scorePtn=''
			
			
			  this.form.batNameSSS = this.categoryList.find(o => o.id == e).batchName;
			  this.form.batNameRemark = this.categoryList.find(o => o.id == e).remark;
			
			
			  this.form.typeName = this.categoryList.find(o => o.id == e).typeName;
			  this.form.rank = this.categoryList.find(o => o.id == e).rank;
			  console.log('this.form.batchIdDataSS',this.form)
			  // 山东 普考类 文化分 去请求位次
			  if(this.form.culture){
			    this.handleInput(this.form.culture)
			  }
			
			},
			// 文化分输入监听
			handleInput(e){
			  // 获取综合分
			  // this.zongheGet()
			  if(e.length>=2&&this.form.batNameSSS=='普通类'||this.form.batNameSSS=='春季高考'){
			    this.form.score  = this.form.culture
			    this.getbatNum()
			  }else if(e.length>=2&&this.form.batNameSSS=='艺术类'){
			    this.getbatNum(this.form.rank)
			    console.log('22222')
			  }
			 
			},
			// 输入完 文化成绩 去请求位次接口
			getbatNum(e){
			  let datas = {
			    rank:e||'',
			    culture:this.form.culture*100,	//int(10) NULL	文化分
			    art:this.form.art*100,	//int(10) NULL	专业分
			    batchId:this.form.batchId,
			    cityId:this.form.cityId,
			    batch:this.form.batNameSSS,
			    year:this.form.cityYear|| this.rowData.year,
			    typeName:this.form.typeName
			  }
			  
			  
			  this.api.GetAppBranchApi(datas).then(res => {
				  if(res.code==200){
				  			
				    if(res.data.total){
				    	this.form.scorePtn = res.data.total
				    }else{
				    	this.form.scorePtn = 0
				    }
				  			
				    if(res.data.score){
				    	if(this.form.batNameSSS=='艺术类'&&datas.culture&&datas.art){
				    		this.form.score = res.data.score
				    	}else if(this.form.batNameSSS=='普通类'||this.form.batNameSSS=='春季高考'){
				    		this.form.score = res.data.score
				    	}
				    }else{
				    	this.form.score = 0
				    }
				  			
				    // this.form.scorePtn = res.msg
				     // this.categoryList = res.data;
				  }else{
					  
				  }
			  })
			//   baokaoBatchApi(datas).then(res => {
			//     console.log('res',res)
			//     if(res.code==200){
			
			//       if(res.data.total){
			//       	this.form.scorePtn = res.data.total
			//       }else{
			//       	this.form.scorePtn = 0
			//       }
			
			//       if(res.data.score){
			//       	if(this.form.batNameSSS=='艺术类'&&datas.culture&&datas.art){
			//       		this.form.score = res.data.score
			//       	}else if(this.form.batNameSSS=='普通类'){
			//       		this.form.score = res.data.score
			//       	}
			//       }else{
			//       	this.form.score = 0
			//       }
			
			//       // this.form.scorePtn = res.msg
			//        // this.categoryList = res.data;
			//     }else{
			//     }
			//   });
			},
			// 选科类型
			xuankeChange(){
			  console.log('选科类型',this.checkboxGroup1)
			  
			  // form.subjectOne
			  
			  // subjectDown
			  
			  this.form.subjectOnes = this.checkedNames()
			},
			checkedNames() {
			    return this.subjectDown.filter(item => this.form.subjectOne.includes(item.id)).map(item => item.name);
			  },
			// @chang
			
			
			/** 添加 提交按钮 */
			submitForm() {
			console.log('this.form.batNames.',this.form.batNameSSS)
			  let formData={
			    id:this.form.id||'',
			    cityId:this.form.cityId,//省份id
			    batchId:this.form.batchId,//int(20) NULL	批次id
			    batNames:this.form.batNameSSS,
			    batchNames: this.form.batNameSSS,
			
			    // batNameSSS:this.form,//判断是普通类还是艺术类
			    // statusType:this.form,	//int(20) NULL	1(6选3), 2(3+1+2), 3(7选3), 4(文理科)
			    name:this.form.name,	//varchar(50) NULL	学生姓名
			    mobile:this.form.mobile,	//varchar(11) NULL	手机号
			    sex:this.form.sex,	//int(1) NULL	1男2女
			    culture:this.form.culture*100,	//int(10) NULL	文化分
			    art:this.form.art*100,	//int(10) NULL	专业分
			    score:(this.form.batNameSSS=='普通类'||this.form.batNameSSS=='春季高考')?this.form.score*100:this.form.score*100,	//int(10) NULL	综合成绩
			    scorePtn:this.form.scorePtn,	//int(10) NULL	位次
			    subjectOne:this.form.subjectOne.toString()||'',//varchar(20) NULL	1物理，2化学，3生物，4历史，5政治，6地理，7文科，8理科
			    subjectOnes:this.form.subjectOnes?this.form.subjectOnes.toString():'',//varchar(20) NULL	1物理，2化学，3生物，4历史，5政治，6地理，7文科，8理科
			    // subjectTwo:this.form.subjectTwo.toString()||'',	//varchar(20) NULL	1物理，2化学，3生物，4历史，5政治，6地理，7文科，8理科
			    // userVip:this.form,	//int(1) NULL	vip，0否，1是
			    // scoreNum:this.form,	//int(5) NULL	分数可修改次数
			    // cityNum:this.form,	//int(5) NULL	省份可修改次数
			    // kemuNum:this.form,	//int(5) NULL	科目可修改次数
			    remark:this.form.remark,	//varchar(200) NULL	备注
			    year:this.form.cityYear,
			
			    rank:this.form.rank||'',
			    typeName:this.form.typeName||'',
				gradeType:1

			
			  }
			  if(!formData.scorePtn||formData.scorePtn==0){
				this.$message.error('请输入位次');
			    return
			  }
			  console.log('formData',formData)
			  
			  // return
			  this.$refs["form"].validate(valid => {
			    if (valid) {
				 this.api.GetAppAddUserApi(formData).then(res => {	
					 if(res.code==200){
					   if(res.data.message=='SUCCESS'){
						   let user = this.user
						   user.batchId = this.form.batchId
						   user.batchName = this.form.batNameSSS
						   user.batchNames = this.form.batNameSSS
						   user.year = this.form.cityYear
						   user.cityId = this.form.cityId
						   user.score = this.form.score*100
						   user.scorePtn =this.form.scorePtn
						   user.culture = this.form.culture*100
						   user.art = this.form.art*100
						   
						   user.rank = this.form.rank
						   user.typeName = this.form.typeName
						   
						   
						   
						   user.subjectOne = this.form.subjectOne.toString()
						   user.subjectOnes = this.form.subjectOnes.toString()
						   user.gradeType = this.form.gradeType
						   user.overdueTime = res.data.overdueTime
						   localStorage.setItem("user", JSON.stringify(user));
						   
						   
						 this.$message.success('操作成功');
					     this.open = false
						 EventBus.$emit('tui');
					     // this.qq()
					     // this.getList();
					   }else{
					     // this.$modal.msgError(res.data.message);
					 	this.$message.error(res.data.message);
					   }
					 			
					 }
				 })
			//       baokaoAddUserApi(formData).then(res => {
			
			//         if(res.code==200){
			
			//           if(res.data.message=='SUCCESS'){
			//             this.$modal.msgSuccess("操作成功");
			//             this.open = false
			//             this.qq()
			//             this.getList();
			//           }else{
			//             // this.$modal.msgError(res.data.message);
			// 			this.$message.error(res.data.message);
			//           }
			
			//         }
			
			
			
			
			
			//       }).catch(() => {
			//         console.log('12121212121212')
			//       });
			    }
			  });
			},
			// 取消按钮
			cancel() {
			  this.reset();
			  this.open = false;
			},
			// 取消按钮（数据权限）
			cancelDataScope() {
			  this.openDataScope = false;
			  this.reset();
			},
			// 表单重置
			reset() {
			  // if (this.$refs.menu != undefined) {
			  //   this.$refs.menu.setCheckedKeys([]);
			  // }
			  this.form={
				  id:'',
			    cityId:'',//省份id
			    cityYear:'',//省份里面带的年 查询位次会用到
			    batchId:'',//int(20) NULL	批次id
			    batNameSSS:'',//判断是普通类还是艺术类
			    batNameRemark:'',//选择完了批次 上面展示提示的提示文字
			    statusType:'',	//int(20) NULL	1(6选3), 2(3+1+2), 3(7选3), 4(文理科)
			    name:'',	//varchar(50) NULL	学生姓名
			    mobile:'',	//varchar(11) NULL	手机号
			    sex:'',	//int(1) NULL	1男2女
			    culture:'',	//int(10) NULL	文化分
			    art:'',	//int(10) NULL	专业分
			    score:'',	//int(10) NULL	综合成绩
			    scorePtn:'',	//int(10) NULL	位次
			    subjectOne:[],//varchar(20) NULL	1物理，2化学，3生物，4历史，5政治，6地理，7文科，8理科
			    userVip:'',	//int(1) NULL	vip，0否，1是
			    scoreNum:'',	//int(5) NULL	分数可修改次数
			    cityNum:'',	//int(5) NULL	省份可修改次数
			    kemuNum:'',	//int(5) NULL	科目可修改次数
			    remark:'',	//varchar(200) NULL	备注
			  }
			  console.log('this.formculture',this.form.culture)
			  // this.resetForm("form");
			},
			
			
			
			// 更多操作触发
			handleCommand(command) {
			  switch (command) {
			    case "handleQuit":
				  localStorage.removeItem('user');
				  localStorage.removeItem('cardType');
				  localStorage.removeItem('token');
				  localStorage.removeItem('pushId');
				  localStorage.removeItem('xiaoid');
				  localStorage.removeItem('loginStatus');
				  localStorage.removeItem('myarrLengrh');
				  localStorage.removeItem('college_arr');
				  localStorage.removeItem('videoInfo');
				  
				  
				  this.user = {}
				  this.token =''
				  
				  
				  EventBus.$emit('tui');
				  this.$router.push({path:'/'})
				  
				 
				  window.location.reload()
			      break;
			    
			    default:
			      break;
			  }
			},
			//验证码和激活码切换
			cardClick(i){
				this.cardIndx = i
			},
			// 底部阅读协议
			xieyiClick() {
				console.log('asdads', this.xieyishow)
				this.xieyishow = !this.xieyishow
			},
			// 获取验证码
			getCode() {
			  let that = this;
			  // else if (that.ruleForm.pass == '') {
			  //   that.$message.error('请输入验证码');
			  //   return
			  // }
			  console.log('1',that.mobile)
			  if (that.mobile == '') {
			    that.$message('请输入手机号');
			    return
			  } else if (that.mobile.length < 11) {
			    that.$message('手机号格式不正确');
			    return
			  } else {
			
			    let params = {
			      mobile: that.mobile,
				  pushFlag : 'XMcKIKUsa8UbMDF'
			    }
			    that.api.GetSysPutCode(params).then(res => {
			      if (res.code==200) {
			        const TIME_COUNT = 60;
			        if (!that.timer) {
			          that.count = TIME_COUNT;
			          that.show = false;
			          that.state = false;
			          that.timer = setInterval(() => {
			            if (that.count > 0 && that.count <= TIME_COUNT) {
			              that.count--;
			            } else {
			              that.show = true;
			              that.state = false;
			              clearInterval(that.timer);
			              that.timer = null;
			
			            }
			          }, 1000)
			        }
			      } else {
			        that.$message.error(res.message);

			      }
			    })
			  }
			
			
			},
			
			// 登录
			formSub(type){
				let that = this;
				if(type==1){
					that.cardNum=""
					if (!that.mobile || !that.codes) {
						that.$message.error('请输入手机号或验证码');
						return
					} else if (that.mobile.length !=11) {
						
						that.$message.error('请输入正确的手机号');
						return
					} else if (!(/^\d{4}$/.test(that.codes))) {
						// uni.showToast({
						// 	title:'请输入正确的验证码',
						// 	icon:'none'
						// })
						that.$message.error('请输入正确的验证码');
						return
					} else if (!that.xieyishow) {
						// uni.showToast({
						// 	title:'请阅读用户协议',
						// 	icon:'none'
						// })
						
						// that.showAlert=true
						
						that.$message.error('请阅读并同意《用户服务协议》及《隐私协议》');
						
						return
					}
					
				}
				if(type==2){
					that.codes=""
					if (that.mobile.length!=11) {
						that.$message.error('请输入正确的手机号');
						return
					} else if (that.cardNum.length!=12) {
						that.$message.error('请输入正确的激活码');
						return
					}  else if (!that.xieyishow) {
						// uni.showToast({
						// 	title:'请阅读用户协议',
						// 	icon:'none'
						// })
						
						// that.showAlert=true
						that.$message.error('请阅读并同意《用户服务协议》及《隐私协议》');
						return
					}
					
				}
				// 防止多次点击
				that.onoff = true;
				setTimeout(function() {
					that.onoff = false;
				}, 500)
				let dataQuer = {
					code:that.codes||'',
					// pushFlag:that.pushFlag,
					pushFlag : 'XMcKIKUsa8UbMDF',
					mobile:that.mobile,
					// userId:that.shareUserid||'',
					cardNum:that.cardNum||''
				}
				console.log('dataQuer',dataQuer)
				this.api.GetADDStuApi(dataQuer).then(res => {
					console.log('res',res)
				  if (res.code==200&& res.data) {
					  
					  if(res.data.message=='SUCCESS'){
						  this.$message({
						    type: "success",
						    message: "登录成功!",
						    duration: '1000'
						  });
						  localStorage.setItem("token", res.data.token);
						  localStorage.setItem("pushId", res.data.pushId);
						  localStorage.setItem("cardType", res.data.cardType);
						  localStorage.setItem("user", JSON.stringify(res.data.user));
						  
						  this.user =res.data.user
						  this.token = res.data.token
						  
						  if(!res.data.user.score){
						  	this.open = true
						  }
						  // if(res.data.data.user.score){
						  // 	if(that.vip=='vip'&&res.data.data.user.userVip==0){
						  // 		uni.redirectTo({
						  // 		    url: '/indexModule/wxpay' // 跳转到对应路径的页面
						  // 		});
						  // 	}else{
						  // 		uni.switchTab({
						  // 		    url: '/pages/index/index' // 跳转到对应路径的tabBar页面
						  // 		});
						  // 	}
						  	
						  // }else{
						  // 	uni.redirectTo({
						  // 	    url: '/pages/examination/examination' // 跳转到对应路径的页面
						  // 	});
						  // }
						  this.addUserShowLL()

						 
						  this.noopsycheOpen = false
						  this.codes=''
						  this.mobile=''
						  this.cardNum=''
						  EventBus.$emit('tui')
						  // 目前登录完直接去请求 现在没号测试登录完完善信息
						  EventBus.$emit('callLoginDialog');
					  }else{
						  this.$message.error(res.data.message);
					  }
				  } else {
				    this.$message.error(res.msg);
				  }
				})
				
			},
			/************S************************************************************************************/
			
			
			// use51La() {
			//   let script = document.createElement("script"); //页面上html部分，要添加的地方
			//   script.src = "/static/tj.js"; //自己处理后的脚本文件
			//   script.type = "text/javascript";
			//   script.id = "tj-51la"; //自定义id
			//   let tj = document.getElementById("tj");
			//   tj.insertBefore(script, tj.children[0]); //插入到前部
			// },
			handleScroll() {
				var scrollTop =
					window.pageYOffset ||
					document.documentElement.scrollTop ||
					document.body.scrollTop;
				if (scrollTop > 150) {
					this.navtab = true;
				} else if (scrollTop < 150) {
					this.navtab = false;
				}
			},
			// async linslins() {
			// 	this.link = await links();
			// },
			async partner() {
				this.partners = await partners();
			},

			// 选择框
			handleSelect(key) {
				this.$router.push(key);
			},
			// 底部三个照片
			chengren() {
				this.$router.push("/Chengkao");
			},
			shenbao() {
				this.$router.push("/shenbao");
			},
			guokai() {
				this.$router.push("/Guojiakaifang");
			},

			// 底部按钮
			zoujinxuemeng() {
				this.$router.push("/Ainformation/introduce");
			},
			qiyejianjie() {
				this.$router.push("/Ainformation/introduce");
			},
			develop() {
				this.$router.push("/Ainformation/develop");
			},
			wenhua() {
				this.$router.push("/Ainformation/culture");
			},
			gaoxiao() {
				this.$router.push("/Ainformation/concern");
			},
			rongyu() {
				this.$router.push("/Ainformation/honor");
			},

			xinwenzhongxin() {
				this.$router.push("/NewsCenter/groupAct");
			},
			hangye() {
				this.$router.push("/NewsCenter/businessAct");
			},
			shipin() {
				this.$router.push("/NewsCenter/videoAll");
			},

			xiaoqu() {
				this.$router.push("/NewsCenter/campusTale");
			},

			yewutixi() {
				this.$router.push("/WorkingSystem/ZCSB/ChuJi");
			},
			xuelijiaouy() {
				this.$router.push("/WorkingSystem/XLJY/CRGK");
			},
			zhiye() {
				this.$router.push("/WorkingSystem/ZYJY/xuexiao");
			},
			zhuanshengben() {
				this.$router.push("/WorkingSystem/ZSB");
			},
			ywtx() {
				this.$router.push("/WorkingSystem/WorkingSY");
			},
		},
		mounted() {
			// this.use51La()
			var div = document.querySelectorAll(".el-menu--popup");
			div.forEach((item) => {
				// item.style.minWidth = "115px";
				item.style.minWidth = "0.61rem";
				// console.log(item);
				// item.style.textAlign='center';
			});

			window.addEventListener("scroll", this.handleScroll);
		},
	};
</script>

<style lang="scss" scoped>
	// <div class="alert">
	// 	<div class="alerttit">手机验证码登录</div>
	// 	<div class="alertcen">
	// 		<div class="alertcenA"><el-input v-model="mobile" placeholder="请输入手机号"></el-input></div>
	// 		<div class="alertcenB">
	// 			<el-input v-model="codes" placeholder="请输入验证码"></el-input> 
	// 			<div v-show="show" class="codebtn" @click="getCode">获取验证码</div>
	// 			<div v-show="!show" class="codebtn" >{{count}}</div>
	// 		 </div>
	// 		 <div class="alertcenC">
	// 			 <div>激活码登录</div>
	// 		 </div>
	// 		 <div class="alertcenD">
	// 			 <div>注册/登录</div>
	// 		 </div>
	// 	</div>
	// </div>	
	// 登录 弹框
	
	.alert{
		.alerttit{
			font-size: 24px;
			font-weight: bold;
			color: #333;
			text-align: center;
			margin-bottom: 30px;
		}
		input:focus {
		  outline: none;
		}
		.alertcenA{
			display: flex;
			justify-content: center;
			input{
				width: 80%;
				height: 45px;
				border-radius: 10px;
				// border-color: #DCDFE6;
				border: 1px solid #DCDFE6;
				padding-left: 10px;
			}
		}
		.alertcenB{
			display: flex;
			justify-content: center;
			margin-top: 10px;
			input{
				width: 64%;
				height: 45px;
				border-radius: 10px;
				// border-color: #DCDFE6;
				border: 1px solid #DCDFE6;
				padding-left: 10px;
			}
			.codebtn{
				width: 15%;
				margin-left: 1%;
				height: 45px;
				border-radius: 10px;
				border: 1px solid #DCDFE6;
				display: flex;
				align-items: center;
				justify-content: center;
				cursor: pointer;
				// color: #F44F4D;
			}
		}
		.alertcenC{
			width: 80%;
			margin: 10px auto;
			text-align: right;
			color: #F44F4D;
			cursor: pointer;
		}
		.alertcenD{
			width: 80%;
			margin: 40px auto 20px;
			div{
				background-color:#F44F4D ;
				color: #fff;
				font-size: 18px;
				height: 50px;
				border-radius: 10px;
				display: flex;
				justify-content: center;
				align-items: center;
				cursor: pointer;
			}
		}
		.xuan {
			font-size: 14px;
			width: 80%;
			margin: 30px auto 10px;
			.xieyi {
				display: flex;
				// /* align-items: center; */
				&-check{
					display: flex;
					align-items: center;
					span {
						font-size: 17px;
						margin-right: 5px;
						cursor: pointer;
					}
				}
				.xieyi-text{
					font-size: 13px;
					color: #333333;
					cursor: pointer;
				}
			}
		}
	
	}
	
	// html{-webkit-text-size-adjust:none;}
	/* 小的不会被彻底覆盖，大的却会 */

	/* PC端样式 */
	// @media screen and (min-width: 768px) {
	//   body {
	//     width: 768px;
	//     margin: 0 auto;
	//   }
	// }

	// /* 手机端样式 */
	// @media screen and (max-width: 767px) {
	//   .body {
	//     width: 100%;
	//     margin: 0;
	//   }
	// }
	// /deep/ .el-menu--popup-bottom-start{
	//   width: 120px;
	// }

	// .el-menu--horizontal .el-menu .el-menu-item,
	// .el-menu--horizontal .el-menu .el-submenu__title {
	//   // background-color: #FFF;
	//   // border: 1px solid blue;
	//   // text-align: center;
	//   font-size: 17px;
	//   // width: 80px;
	//   // float: none;
	//   height: 50px;
	//   line-height: 50px;
	//   // padding: 0 10px;
	//   color: #000;
	//   text-align: center;
	// }
	// 修改下拉菜单的
	.el-menu--horizontal .el-menu .el-menu-item {
		// width: 1000px;
		// padding: 0px -100px;
		// background-color: blue;
		font-size: 14px;
		height: 40px;
		text-align: center;
		color: #000;
	}

	// 鼠标经过下拉框每一项时的hover效果
	.el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
	.el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
		outline: 0;
		color: #F56C6C;
	}

	::v-deep .el-submenu__title {
		.el-icon-arrow-down {
			display: none;
		}
	}
	
	
	// 选中后隐藏下面的线
	::v-deep .el-menu--horizontal>.el-menu-item{
		border-bottom: none!important;
	}
	::v-deep .el-menu--horizontal>.el-menu-item.is-active{
		border-bottom: none!important;
	}
	::v-deep .el-menu--horizontal>.el-submenu .el-submenu__title{
		border-bottom: none!important;
	}
	::v-deep .el-menu--horizontal>.el-submenu.is-active .el-submenu__title{
		border-bottom: none!important;
	}
	::v-deep .el-submenu__title:active {
		border-bottom-color: #F56C6C;
	}

	::v-deep.el-menu--popup {
	  overflow: hidden;
	  border-radius: 4px!important;
	}
	* {
		// margin: 0;
		// padding: 0;
		box-sizing: border-box;
	}

	// html{
	//   width: 100%;
	//   height: 100%;
	// }
	.box {
		// position: relative;
		// width: 100%;
		// height: 100%;
		display: flex;
		flex-direction: column;
		// overflow-x: hidden;
		// background: #F8F8F8;
		.font {
			font-size: 16px;
		}

		.nav_div {
			// flex: 1;
			// height: 115px;
			width: 80%;
			// display: flex;
			margin: 20px auto 6px;
			.nav_div_top{
				display: flex;
				align-items: center;
				height: 48px;
				.nav_div_top-c{
					height: 40px;
					display: -webkit-box;
					display: -webkit-flex;
					display: -ms-flexbox;
					display: flex;
					-webkit-box-pack: justify;
					-webkit-justify-content: space-between;
					-ms-flex-pack: justify;
					flex: 1;
					margin-left: 20px;
					
					
					.elbu-vip{
						padding: 0 20px!important;
						color:#613700;
						img{
							width: 22px;
							height: 16px;
							margin-right: 5px;
						}
					}
					
					.input-with-select{
						margin-left: 45px;
						margin-right: 40px;
						border-radius: 4px;
						/deep/.el-input__inner{
							border-color: #F56C6C!important;
						}
						/deep/.el-button--danger{
							border: none!important;
						}
						/deep/.el-button{
							border: 1px solid #f44f4d!important;
							background: #f44f4d;
							color: #fff;
							border-radius: 0  4px 4px 0px;
						}
					}
				}
			}
			
			.nav_div_title {
				padding: 0px 10px;
			}
/deep/.el-menu--horizontal>.el-submenu{
					margin-right: 20px!important;
				}
			
			// 中间导航栏
			.el-menu-demo {
				// width: 800px;
				margin: auto 10px;
				padding-top: 10px;
				border-bottom: none;
				
				/deep/.el-icon-caret-bottom{
					margin-right: 0;
				}
				
				/deep/.el-menu-item{
					height: 40px!important;
					line-height: 40px!important;
				}
				/deep/.el-submenu__title{
					height: 40px!important;
					line-height: 40px!important;
				}
				// 每一项
				.el-menu-item {
					font-size: 18px;
					padding: 0 20px;
					font-weight: bold;
					color: #31374c !important;
					border-bottom-color: #F56C6C;
					display: flex;
					align-items: center;
					margin-right: 20px;
				}

				// 每一项的激活
				.el-menu-item.is-active {
					color:#f44f4d !important;
					
				}

				// 每一项的hover
				.el-menu-item:hover {
					color:#f44f4d !important;
				}

				
				.el-submenu /deep/ .el-submenu__title {
					font-size: 18px;
					font-weight: bold;
					color: #31374c !important;
					border-bottom-color: #f44f4d;
					display: flex;
					align-items: center;
				}

			
				.el-submenu /deep/ .el-submenu__title:hover {
					// background-color: #f44f4d;
					color: #f44f4d !important;
					// .el-icon-caret-bottom{
					// 	transform: rotate(180deg) !important;
					// }
				}

			
			}

			// 左侧logo
			.nav_left_div {
				position: relative;
				z-index: 99;
				font-size: 30px;
				color: #F44F4D;
				.nav_left_div_img {
					object-fit: cover;
					// width: 70px;
					height: 60px;
					image-rendering: -webkit-optimize-contrast;
				}
			}

			// 右侧电话
			.nav_right_div {
				width: 300px;
				margin-top: 10px;
				display: flex;
				justify-content: center;
				align-items: center;
				margin-left: -30px;
				.nav_right_div_img {
					margin-right: 10px;
					width: 25px;
					height: 25px;
					margin-top: -1px;
					vertical-align: middle;
				}

				.nav_right_div_span {
					font-size: 24px;
					font-weight: 800;
					color: #F56C6C;
					vertical-align: middle;
				}
			}

			/deep/ .el-menu--horizontal {
				display: block;
			}
		}

		.middle_div {
			//  flex: 1;
			// margin-bottom: 60px;
			background-color: rgb(246, 246, 246);
		}

		// 下面照片
		.home_box_kaoshi {
			width: 1300px;
			margin: 0 auto;
			margin-bottom: 60px;
			display: flex;
			justify-content: space-around;

			img {
				width: 400px;
				// height: 80px;
				border-radius: 10px;
				object-fit: cover;
			}
		}

		// 版权底部所有信息
		.buttom_div {
			width: 100%;
			background-color: #0d152a;
			padding-top: 10px;

			.buttom_top {
				width: 1400px;
				height: 30px;
				margin: 0 auto;
				margin-top: 10px;
				display: flex;

				.link {
					// width: 60px;ss
					height: 100%;
					background-color: #F56C6C;
					padding-left: 10px;
					padding-right: 10px;
					margin-left: 20px;
					border-radius: 10px;
					font-size: 13px;
					color: #fff;
					font-weight: 600;
					display: flex;
					justify-content: center;
					align-items: center;
				}

				.link_item {
					height: 100%;
					display: flex;

					li {
						margin-left: 15px;
						height: 100%;
						// width: 70px;
						display: flex;
						justify-content: center;
						align-items: center;

						a {
							height: 100%;
							font-size: 11px;
							display: flex;
							justify-content: center;
							align-items: center;
							text-decoration: none;
							/* 去除默认的下划线 */
							outline: none;
							/* 去除旧版浏览器的点击后的外虚线框 */
							color: #fff;

							/* 去除默认的颜色和点击后变化的颜色 */
							.img {
								border-radius: 10px;
								width: 90px;
								height: 100%;
								object-fit: cover;
							}
						}

						.alink {
							width: 90px;
							border-radius: 10px;
							//  background-color: #fff;
							// padding-right: 5px;
							// color: #000;
							font-size: 13px;
							font-weight: 600;
							// padding-left: 5px;
						}

						&:hover a {
							color: #F56C6C !important;
							opacity: 0.8;
						}
					}
				}
			}

			.buttom_nav {
				display: flex;
				justify-content: space-between;
				align-items: center;
				height: 220px;
				width: 1360px;
				margin: 0 auto;
				margin-top: 20px;

				// 左侧盒子 走进学盟
				.buttom_nav_left {
					display: flex;
					justify-content: space-between;
					flex: 1;
					height: 100%;
					padding-right: 90px;
					border-right: 1px solid #fff;
					color: #fff;

					ul {
						display: flex;
						flex-direction: column;
						align-items: center;

						.frist_li {
							font-size: 19px;
							font-weight: 600;
						}

						li {
							font-size: 14px;
							margin-bottom: 15px;
						}

						li:hover {
							color: #F56C6C;
						}

						li:active {
							color: red;
						}
					}
				}

				// 中间盒子 联系我们
				.buttom_nav_center {
					flex: 0.8;
					height: 100%;
					border-right: 1px solid #fff;
					color: #fff;
					padding-left: 70px;

					ul {
						.frist_li {
							font-size: 19px;
							font-weight: 600;
						}

						li {
							font-size: 14px;
							margin-bottom: 18px;
						}

						.youxiang {
							margin-bottom: 30px;
						}
					}

					// .dizhi{
					//   width: 250px;
					//   // font-size: 22px;
					//   font-size: 18px;
					//   font-weight: 600;
					// }
				}

				// 右边盒子 二维码
				.buttom_nav_right {
					display: flex;
					flex-direction: column;
					justify-content: space-around;
					flex: 1;
					height: 100%;
					text-align: center;
					padding-left: 40px;

					ul {
						display: flex;
						justify-content: space-evenly;
						align-items: center;
						font-size: 15px;
						color: #fff;

						li {
							// text-align: center;
							width: 94px;
							height: 94px;

							.li_div {
								img {
									width: 100%;
									height: 100%;
									object-fit: cover;
								}
							}
						}
					}

					.buttom_nav_right_search {
						margin-top: 15%;

						img {
							width: 70%;
							height: 70%;
							object-fit: cover;
						}
					}
				}
			}

			// 下面的版权盒子
			.buttom_bottom {
				width: 1360px;
				margin: 0 auto;
				color: #fff;
				border-top: 1px solid #fff;
				margin-top: 20px;
				padding-top: 20px;
				padding-bottom: 20px;
				font-size: 15px;
				display: flex;
				justify-content: center;
				align-items: center;

				a {
					text-decoration: none;
					/* 去除默认的下划线 */
					outline: none;
					/* 去除旧版浏览器的点击后的外虚线框 */
					color: #fff;

					/* 去除默认的颜色和点击后变化的颜色 */
					&:hover {
						// color: #F56C6C;
					}
				}
			}
		}
	}
	
	
	
.view-dialog /deep/.el-dialog {
  border-radius: 10px!important;
}
.el-select{
	width: 100%;
}


// 激活vip弹框
.userbox{
			margin: -5px 15px 25px 15px;
			border-radius:8px;
			background: #FFFFFF;
			box-shadow: 3px 5px 15px  #CCCCCC;
			padding: 20px 17px;
			display: flex;
			align-items: center;
			position: relative;
			z-index: 2;
			.userboxl{
				width: 80%;
				.userboxla{
					font-size: 18px;
					font-weight: 700;
					line-height: 25px;
					color: rgba(51, 51, 51, 1);
				}
				.userboxlb{
					font-size: 13px;
					font-weight: 500;
					line-height:25px;
					color: #666666;
				}
				.userboxlc{
					font-size: 13px;
					font-weight: 700;
					letter-spacing: 0px;
					line-height:18px;
					color:#E85E27;
				}
			}
			.userboxr{
				// <div class="userboxrbMain" @click="kmClick()" v-if="user.userVip==0">
				// 	 <input type="text" placeholder="请输入激活码" maxlength="12"> 
				// 	 <div class="userboxrb">
				// 		 卡密激活
				// 	 </div>
				// </div>
				.userboxrbMain{
					display: flex;
					align-items: center;
					input{
						width: 180px;
						height: 30px;
						border: 1px solid #DCDFE6;
						padding-left: 10px;
						border-radius: 4px;
						margin-right: 6px;
					}
					input:focus {
					  outline: none;
					}
				}
				
				
				
				.userboxrb{
					width: 90px;
					height: 30px;
					border-radius: 100px;
					background: linear-gradient(90deg, #FAAF3E 0%, #F73131 100%);
					display: flex;
					justify-content: center;
					align-items: center;
					color: #fff;
					font-size: 14px;
					cursor: pointer
				}
			}
		}
.qymain{
			margin: 0 15px;
			.qymaintop{
				position: relative;
				image{
					width: 172px;
					height: 50px;
					position: relative;
					z-index: 1;
				}
				.qymaintop-tit{
					position: absolute;
					left: 15px;
					top: 12px;
					font-size: 16px;
					z-index: 333;
					color: #fff;
				}
			}
			.qymainlist{
				margin-top: -65px;
				border-radius: 15px;
				background: #FFFFFF;
				border: 1px solid #F5D5AA;
				position: relative;
				z-index: 2;
				padding: 15px 0 15px 15px;
				display: flex;
				.qymainlistl{
					flex:1;
					
					.qymainlistl-top{
						line-height: 50px;
						font-size: 18px;
						font-weight: 700;
						color: #333;
					}
					.qymainlistl-topb{
						text-align: center!important;
					}
					.qymainlistl-listb{
						text-align: center!important;
						.el-iconNew{
							display: block;
							line-height: 38px;
						}
					}
					.qymainlistl-listback{
						border-radius: 15px;
						background: #FFF9EF;
						border: 1px solid #FAEBC0;
						
					}
					.qymainlistl-list{
						
						.qymainlistllist-li{
							line-height: 38px;
							font-size: 14px;
							color: #333;
						}
					}
				}
				
				.qymainlistlback{
					background-color: #FAEBC0;
					border-radius: 15px;
				}
			}
			
			.explain-box{
				.explain-b-tit{
					font-size: 18px;
					color: #333333;
					font-weight: 700;
					padding: 25px 0 10px 0;
				}
				// 免责
				.explain-boxulmz{
					color: #666;
					font-size:14px;
					line-height: 25px;
					padding: 0 15px;
				}
				// 使用说明
				.explain-boxul{
					border-radius: 10px;
					background: #FFFFFF;
					border: 1px solid #F5D5AA;
					padding: 20px 15px 20px 15px;
					.explain-boxul-li{
						display: flex;
						margin-bottom: 15px;
						.exnum{
							width: 24px;
							height: 24px;
							border-radius: 50%;
							background: linear-gradient(90deg, #FCB186 0%, #CF7D4E 100%);
							display: flex;
							align-items: center;
							justify-content: center;
							font-size: 16px;
							color: #fff;
							margin-right: 15px;
						}
						.extext{
							flex: 1;
							font-size: 15px;
							color: rgba(102, 102, 102, 1);
						}
					}
				}
			}
			// <view class="explain-box">
			// 	<view class="explain-b-tit"> 使用说明 </view>
				
			// 	<view class="explain-boxul">
			// 		<view class="explain-boxul-li">
			// 			<text class="exnum">1</text>
			// 			<view class="extext">开通VIP前请确认开通省份和高考年份，开通后无法修改西藏地区暂不支持服务。</view>
			// 		</view>
			// 	</view>
				
			// </view>
		}
		/deep/.el-checkbox-button.is-checked .el-checkbox-button__inner{
			background-color: #F34240!important;
			    border-color: #F34240!important;
			    box-shadow: -1px 0 0 0 #F34240!important;
		}
		/deep/.el-input.is-active .el-input__inner{
			// border-color: #F34240!important;
			 border-color:#DCDFE6!important;
		} 
		/deep/.el-input__inner:focus{
			// border-color: #F34240!important;
			border-color:#DCDFE6!important;
		}
		.el-select-dropdown__item.selected {
		  color: #F34240!important
		}
		.blur{
			filter: blur(20rpx);
		}
		
		
		
		
		
		.session{
			position: fixed;
			z-index: 999;
			right: 10px;
			bottom: 16vh;
			img{
				width: 57px;
				height: 66px;
				// box-shadow: 0px 2px 4px  #151515;
			}
		}	
	.maintopcen{
		display: flex;
		align-items: center;
		margin-bottom: 10px;
	}
</style>
